__turbopack_context__.v({
  "freeBox": "PlasmicBackToTopStyled-module__spS6-G__freeBox",
  "freeBoxglobal_themeOrange_override": "PlasmicBackToTopStyled-module__spS6-G__freeBoxglobal_themeOrange_override",
  "root": "PlasmicBackToTopStyled-module__spS6-G__root",
  "rootglobal_themeOrange_override": "PlasmicBackToTopStyled-module__spS6-G__rootglobal_themeOrange_override",
  "svg": "PlasmicBackToTopStyled-module__spS6-G__svg",
});
